import React from 'react'
import PropTypes from 'prop-types'
// import R from 'ramda'

import {
  Container
} from 'semantic-ui-react'

import InstitutionItem from './institution'

const displayNone = {display: 'none'}

const ThirdPartyInstitution = props => (
  <Container textAlign='left' fluid style={props.display ? {} : displayNone} >
    <InstitutionItem

      institution={props.institution}

      isLoading={props.request.isLoading === props.institutionId}

      onRefreshInstitution={props.onRefreshInstitution}
      keyFuncs={props.keyFuncs}
      acFuncs={props.acFuncs}
      acData={props.acData}

    />
  </Container>)

ThirdPartyInstitution.propTypes = {
  display: PropTypes.bool.isRequired,
  institutionId: PropTypes.string.isRequired,
  // mapStateToProps
  request: PropTypes.object.isRequired,
  institution: PropTypes.object.isRequired,
  acData: PropTypes.object.isRequired,

  // mapDispatchToProps
  onRefreshInstitution: PropTypes.func.isRequired,

  keyFuncs: PropTypes.object.isRequired,
  acFuncs: PropTypes.object.isRequired
}

export default ThirdPartyInstitution



// WEBPACK FOOTER //
// ./webAdmin/components/thirdParty/page.js